<scf-user-profiles-single
  *ngIf="!showAttributions"
  [isUpdate]="true"
  (selectedProfile)="viewAttributions($event)"
></scf-user-profiles-single>

<scf-user-atributions
  *ngIf="showAttributions"
  [profileToUpdate]="profileToUpdate"
  [isUpdate]="true"
  (update)="updateProfile($event)"
></scf-user-atributions>
